import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRecycle } from "@fortawesome/free-solid-svg-icons";
import PurgeProjectPopup from "./PurgeProjectPopup";
import { usePurgeProject } from "../queries/use-purge-project";

export const PurgeButton = ({ projectId, version }) => {
  const [showDelete, setShowDelete] = useState(false);
  return (
    <>
      <button
        type="button"
        className="inline-flex items-center gap-2 h-9 px-4 rounded-full bg-red-500 text-white text-sm font-semibold shadow-sm hover:opacity-95 transition"
        onClick={() => setShowDelete(true)}
      >
        <FontAwesomeIcon className="w-3.5 h-3.5" icon={faRecycle} />
        Purge
      </button>
      {showDelete && (
        <PurgeProjectPopup
          projectId={projectId}
          version={version}
          onClose={() => setShowDelete(false)}
        />
      )}
    </>
  );
};
